export const allProducts = [
  // A Series - Office Modules
  {
    id: 'a6-compact',
    name: 'A6 Compact',
    category: 'Office Module',
    price: 'POA',
    thumbnail: '/images/e6379fec28de.webp',
    images: [
      '/images/68e167f691a1.webp',
      '/images/21c9f7978b61.webp',
    ],
    floorPlans: [],
    description: 'Ideal compact workspace solution. Perfect for solo entrepreneurs and small businesses.',
    useCase: 'Home offices, backyard workspaces, remote work pods, study rooms, small business offices',
    features: [
      'Perfect for solo entrepreneurs',
      'Integrated desk & storage',
      'Energy-efficient LED lighting',
      'Smart climate control',
      'Space-efficient design',
      'Essential connectivity options',
    ],
  },
  {
    id: 'a9-standard',
    name: 'A9 Standard',
    category: 'Office Module',
    price: 'POA',
    thumbnail: '/images/c28c289e3bc5.webp',
    images: [
      '/images/4373686ea26b.webp',
      '/images/edafa2d8532a.webp',
    ],
    floorPlans: [],
    description: 'Versatile workspace for small teams. Spacious meeting area with separate work zones.',
    useCase: 'Team offices, creative studios, small business workspaces, collaborative environments',
    features: [
      'Spacious meeting area',
      'Separate work zones',
      'Premium sound insulation',
      'Advanced HVAC system',
      'High-speed connectivity',
      'Flexible layout options',
    ],
  },
  {
    id: 'a12-executive',
    name: 'A12 Executive',
    category: 'Office Module',
    price: 'POA',
    thumbnail: '/images/8b41f7de70a0.webp',
    images: [
      '/images/8b8796697489.webp',
      '/images/7cf019a46340.webp',
    ],
    floorPlans: [],
    description: 'Premium workspace for executives. Includes conference room, kitchenette & restroom.',
    useCase: 'Executive offices, corporate workspaces, premium business environments, professional studios',
    features: [
      'Executive office suite',
      'Conference room',
      'Kitchenette & restroom',
      'Premium finishes',
      'Advanced climate control',
      'Smart office automation',
    ],
  },
  {
    id: 'a-s-elite',
    name: 'A-S Elite',
    category: 'Office Module',
    price: 'FROM $48,620',
    thumbnail: '/images/65a595c1c44c.webp',
    images: [
      '/images/cf78618df65a.webp',
      '/images/3b360a029ea6.webp',
    ],
    floorPlans: [
      '/images/5e1c98756dff.webp',
    ],
    description: 'Elite compact workspace solution with premium materials and enhanced features.',
    useCase: 'Premium home offices, professional studios, consulting rooms, high-end workspaces',
    features: [
      'Premium compact design',
      'Enhanced insulation system',
      'High-end interior finishes',
      'Advanced ventilation',
      'Superior comfort',
      'Quick installation',
    ],
  },
  {
    id: 'a-p3-elite',
    name: 'A-P3 Elite',
    category: 'Office Module',
    price: 'FROM $51,040',
    thumbnail: '/images/20363215da46.webp',
    images: [
      '/images/f779c711ffe9.webp',
      '/images/29d1735260e9.webp',
    ],
    floorPlans: [
      '/images/5e1c98756dff.webp',
    ],
    description: 'Premium elevated workspace with enhanced ceiling height for a more spacious feel.',
    useCase: 'Small team offices, creative workspaces, professional studios, collaborative environments',
    features: [
      'Elevated ceiling height',
      'Spacious interior layout',
      'Premium glass system',
      'Enhanced natural lighting',
      'Superior ventilation',
      'Professional environment',
    ],
  },
  {
    id: 'a-p5-elite',
    name: 'A-P5 Elite',
    category: 'Office Module',
    price: 'FROM $53,130',
    thumbnail: '/images/6a50655936e4.webp',
    images: [
      '/images/6a50655936e4.webp',
      '/images/e1fa3474346d.webp',
    ],
    floorPlans: [
      '/images/f3705140c0dc.webp',
    ],
    description: 'Extended elite workspace with multiple functional zones. Perfect for growing teams.',
    useCase: 'Team offices, collaborative workspaces, growing businesses, multi-functional environments',
    features: [
      'Extended workspace area',
      'Multiple work zones',
      'Premium climate control',
      'Professional meeting space',
      'Enhanced comfort',
      'Superior productivity',
    ],
  },
  {
    id: 'a-p7-elite',
    name: 'A-P7 Elite',
    category: 'Office Module',
    price: 'FROM $62,150',
    thumbnail: '/images/f31cf4a3e2cc.webp',
    images: [
      '/images/f31cf4a3e2cc.webp',
      '/images/555cd63ffff0.webp',
    ],
    floorPlans: [
      '/images/6d84c38942df.webp',
    ],
    description: 'Ultimate elite workspace solution with maximum capacity and premium features.',
    useCase: 'Executive offices, established teams, comprehensive workspaces, premium business environments',
    features: [
      'Maximum workspace capacity',
      'Executive meeting room',
      'Multiple functional zones',
      'Premium amenities included',
      'Full facilities',
      'Ultimate comfort',
    ],
  },
  {
    id: 'a-p8-double-layer',
    name: 'A-P8 Double Layer',
    category: 'Office Module',
    price: 'From $125,000',
    thumbnail: '/images/5c4a47384fa7.webp',
    images: [
      '/images/51043bb45990.webp',
      '/images/5c4a47384fa7.webp',
    ],
    floorPlans: [
      '/images/61b68bc95a8a.webp',
    ],
    description: 'Innovative double-layer workspace maximising vertical space efficiency. Two separate floors provide distinct functional zones.',
    useCase: 'Large teams, multi-functional offices, businesses requiring maximum space utilization, innovative workspaces',
    features: [
      'Two-level workspace design',
      'Separate floors for different functions',
      'Enhanced vertical space utilization',
      'Premium double-layer construction',
      'Integrated staircase',
      'Maximum capacity',
    ],
  },
  // M Series - Modular Living
  {
    id: 'm5',
    name: 'M5',
    category: 'Modular Living',
    price: 'FROM $59,180',
    thumbnail: '/images/7f3649eeefc8.webp',
    images: [
      '/images/7f3649eeefc8.webp',
      '/images/b7c34894f8a7.webp',
    ],
    floorPlans: [
      '/images/8f253892013a.webp',
    ],
    description: 'Perfect balance of space and portability with stunning panoramic windows for nature immersion. 26 m² living space with 18 modules.',
    useCase: 'Eco-resorts in remote locations, private retreats in challenging terrain, island resorts, mountain retreats, forest cabins',
    features: [
      '18 detachable modules (max 50kg each)',
      'Dimensions: 7.56m × 3.6m × 3.2m',
      '26 m² floor area',
      '1-2 persons occupancy',
      '2-3 day assembly time',
      'Panoramic Views & All-Terrain',
    ],
  },
  {
    id: 'm7',
    name: 'M7',
    category: 'Modular Living',
    price: 'FROM $74,140',
    thumbnail: '/images/4f4d4413e7ef.webp',
    images: [
      '/images/4f4d4413e7ef.webp',
      '/images/bdcf86bd9402.webp',
    ],
    floorPlans: [
      '/images/ff392a8a810c.webp',
    ],
    description: 'Extended living space with complete amenities. Ideal for families or those seeking ultimate comfort in remote locations. 36 m² with 24 modules.',
    useCase: 'Premium eco-resorts, cliffside retreats, mountain sanctuaries, permanent remote residences, luxury eco-lodges',
    features: [
      '24 detachable modules (max 55kg each)',
      'Dimensions: 10m × 3.6m × 3.2m',
      '36 m² floor area',
      '2-4 persons occupancy',
      '3 day assembly time',
      'Maximum Space & Full Amenities',
    ],
  },
  {
    id: 'm9',
    name: 'M9',
    category: 'Modular Living',
    price: 'FROM $75,460',
    thumbnail: '/images/014b41d04a33.webp',
    images: [
      '/images/014b41d04a33.webp',
      '/images/a0ccca3617a2.webp',
    ],
    floorPlans: [
      '/images/e9f81dba7910.webp',
    ],
    description: 'The ultimate modular solution offering maximum space and luxury for the most demanding remote installations. 38 m² with 28 modules.',
    useCase: 'Permanent luxury residences, most remote and challenging locations, polar research stations, ultimate eco-retreats',
    features: [
      '28 detachable modules (max 55kg each)',
      'Dimensions: 11.5m × 3.3m × 3.2m',
      '38 m² floor area',
      '2-4 persons occupancy',
      '3-4 day assembly time',
      'Maximum Capacity & Ultimate Comfort',
    ],
  },
  // X Series - Living Capsules
  {
    id: 'x3',
    name: 'X3',
    category: 'Living Capsule',
    price: 'FROM $45,760',
    thumbnail: '/images/71de8de379a3.webp',
    images: [
      '/images/71de8de379a3.webp',
      '/images/ai-luxury-compact-capsule-house-interior-mo-eeb60a.webp',
    ],
    floorPlans: [
      '/images/09d9325f4698.webp',
    ],
    description: 'Compact and agile, perfect for high-end glamping or private studios. Full X Series experience in a smaller package.',
    useCase: 'High-end glamping, private studios, solo accommodations, compact luxury living',
    features: [
      'Compact Design',
      'High-end Glamping Ready',
      'Premium Materials',
      'Smart Technology Integration',
      'Exceptional Build Quality',
      'Space-efficient Layout',
    ],
  },
  {
    id: 'x5',
    name: 'X5',
    category: 'Living Capsule',
    price: 'FROM $54,670',
    thumbnail: '/images/65c0b0130fa8.webp',
    images: [
      '/images/65c0b0130fa8.webp',
      '/images/ai-spacious-capsule-house-interior-panorami-a796c9.webp',
    ],
    floorPlans: [
      '/images/cc88e092394d.webp',
    ],
    description: 'Features a panoramic balcony and bedroom skylight for an immersive nature experience. Perfect for eco-tourism resorts.',
    useCase: 'Eco-tourism resorts, permanent residences, couples retreats, nature-focused accommodations',
    features: [
      'Panoramic Balcony',
      'Bedroom Skylight',
      'Nature Experience',
      'Expanded Living Space',
      'Modern Comforts',
      'Premium Finishes',
    ],
  },
  {
    id: 'x6',
    name: 'X6',
    category: 'Living Capsule',
    price: 'FROM $62,150',
    thumbnail: '/images/8ccdb45466f9.webp',
    images: [
      '/images/8ccdb45466f9.webp',
      '/images/ai-large-capsule-house-interior-extended-li-6b5cf4.webp',
    ],
    floorPlans: [
      '/images/992aab6460ee.webp',
    ],
    description: 'Extended living space with a dedicated equipment room for maximum utility. Perfect for off-grid installations.',
    useCase: 'Off-grid installations, utility-focused living, extended stays, self-sufficient accommodations',
    features: [
      'Extended Space',
      'Dedicated Equipment Room',
      'Maximum Utility',
      'Off-grid Ready',
      'Additional Storage',
      'Luxury Living',
    ],
  },
  {
    id: 'x7',
    name: 'X7',
    category: 'Living Capsule',
    price: 'FROM $66,660',
    thumbnail: '/images/8d92522722bb.webp',
    images: [
      '/images/8d92522722bb.webp',
      '/images/ai-flagship-luxury-capsule-house-interior-m-67ab0e.webp',
    ],
    floorPlans: [
      '/images/53d24f4a9591.webp',
    ],
    description: 'The flagship model offering maximum luxury, large panoramic views, and a spacious layout. Ultimate living experience.',
    useCase: 'Permanent residences, premium vacation rentals, executive retreats, luxury accommodations',
    features: [
      'Maximum Luxury',
      'Panoramic Views',
      'Spacious Layout',
      'Flagship Model',
      'Premium Experience',
      'Uncompromising Quality',
    ],
  },
  {
    id: 'y6',
    name: 'Y6',
    category: 'Living Capsule',
    price: 'FROM $53,130',
    thumbnail: '/images/nx-y6-white-background-46281b.webp',
    images: [
      '/images/nx-y6-white-background-46281b.webp',
    ],
    floorPlans: [
      '/images/32b9612143bf.webp',
    ],
    description: 'Cabin-style living capsule with wooden exterior and panoramic balcony. Designed for a warm, nature-connected living experience with modern comforts and premium build quality.',
    useCase: 'Eco-tourism resorts, nature retreats, premium glamping, boutique accommodations',
    features: [
      'Cabin Style Design',
      'Wooden Exterior',
      'Panoramic Balcony',
      'Nature Connected',
      'Premium Build Quality',
      'Modern Comforts',
    ],
  },
  {
    id: 'v6',
    name: 'V6',
    category: 'Living Capsule',
    price: 'FROM $72,160',
    thumbnail: '/images/nx-p03-img01-4472ca.webp',
    images: [
      '/images/nx-p03-img01-4472ca.webp',
    ],
    floorPlans: [
      '/images/e698e533a57a.webp',
    ],
    description: 'Innovative triangle-shaped double-layer living capsule with a dramatic glass facade. Maximises vertical space efficiency with two separate floors for a distinctive and spacious living experience.',
    useCase: 'Permanent residences, luxury vacation rentals, distinctive architectural projects, nature retreats',
    features: [
      'Triangle Design',
      'Double Layer',
      'Glass Facade',
      'Maximum Space',
      'Vertical Efficiency',
      'Distinctive Architecture',
    ],
  },
  // Z Series - Living Capsules
  {
    id: 'z-luxury',
    name: 'Z-Luxury',
    category: 'Living Capsule - Coming Soon',
    price: 'Coming Soon',
    thumbnail: '/images/ai-luxury-futuristic-modular-space-capsule--8fd8ad.webp',
    images: [
      '/images/ai-luxury-futuristic-modular-space-capsule--9139c0.webp',
      '/images/ai-luxury-futuristic-space-capsule-interior-517ea1.webp',
      '/images/ai-luxury-space-capsule-bedroom-area-with-p-77039a.webp',
      '/images/ai-luxury-space-capsule-bathroom-with-premi-5e4611.webp',
    ],
    floorPlans: [],
    description: 'Premium living experience with top-tier amenities and spacious design. Perfect for luxury glamping resorts and high-end vacation rentals.',
    useCase: 'Luxury vacation rentals, premium glamping resorts, exclusive retreat centers, high-end temporary accommodation',
    features: [
      'Panoramic smart glass with privacy control',
      'Premium interior finishes and materials',
      'Full kitchen with high-end appliances',
      'Spa-quality bathroom with rainfall shower',
      'Climate control system with air purification',
      'Integrated smart home automation',
    ],
  },
  {
    id: 'z-standard',
    name: 'Z-Standard',
    category: 'Living Capsule - Coming Soon',
    price: 'Coming Soon',
    thumbnail: '/images/ai-standard-futuristic-modular-space-capsul-6f82e7.webp',
    images: [
      '/images/ai-standard-futuristic-modular-space-capsul-e3414f.webp',
      '/images/ai-standard-space-capsule-interior-comforta-9b37b3.webp',
      '/images/ai-standard-space-capsule-sleeping-area-wit-fcd917.webp',
    ],
    floorPlans: [],
    description: 'Balanced design offering comfort and functionality at an accessible price point. Ideal for vacation rentals and extended stays.',
    useCase: 'Vacation rentals, glamping sites, temporary housing, guest accommodations, eco-resorts',
    features: [
      'Large panoramic windows with natural light',
      'Comfortable living and sleeping areas',
      'Compact kitchen with essential appliances',
      'Modern bathroom with shower',
      'Efficient climate control system',
      'Smart lighting and temperature control',
    ],
  },
  {
    id: 'z-compact',
    name: 'Z-Compact',
    category: 'Living Capsule - Coming Soon',
    price: 'Coming Soon',
    thumbnail: '/images/ai-compact-futuristic-modular-space-capsule-a705aa.webp',
    images: [
      '/images/ai-compact-futuristic-modular-space-capsule-0a001c.webp',
      '/images/ai-compact-space-capsule-interior-efficient-6078f2.webp',
    ],
    floorPlans: [],
    description: 'Space-efficient design maximising functionality in a compact footprint. Perfect for solo travelers and minimalist living.',
    useCase: 'Solo accommodations, backyard studios, minimalist living, budget-friendly glamping, temporary housing',
    features: [
      'Efficient space utilization design',
      'Multi-functional furniture and storage',
      'Kitchenette with basic amenities',
      'Compact bathroom with shower',
      'Energy-efficient climate control',
      'Smart space-saving solutions',
    ],
  },
];